import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  class: "",
  title: "Sigla"
}, "Sigla", -1)
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  class: "",
  title: "Casas decimais"
}, "Casas decimais", -1)
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_10 = { class: "ant-row" }
const _hoisted_11 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_12 = { class: "ant-row" }
const _hoisted_13 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_14 = { class: "ant-row ss-margin-campos" }
const _hoisted_15 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode(" Digite no campo abaixo as seguintes informações: "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("b", null, "Letra v ou q:"),
  /*#__PURE__*/_createTextVNode(" exibe as variáveis disponíveis para utilizar no cálculo "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("b", null, "Operadores disponíveis: "),
  /*#__PURE__*/_createTextVNode(" + Soma, - Subtração, * Multiplicação, / Divisão "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("b", null, "Parênteses ( ou ) :"),
  /*#__PURE__*/_createTextVNode(" para organizar melhor os valores e priorizar cálculos antes de uma divisão ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_icone = _resolveComponent("icone")!
  const _component_selecionar_tipo_item = _resolveComponent("selecionar-tipo-item")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_selecionar_casas_decimais_valor = _resolveComponent("selecionar-casas-decimais-valor")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_selecionar_empresa = _resolveComponent("selecionar-empresa")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_mentions = _resolveComponent("a-mentions")!
  const _component_card = _resolveComponent("card")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      keyboard: false,
      centered: "",
      width: 900,
      visible: _ctx.modalBase.computedVisivel,
      "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
      "wrap-class-name": "ss-modal-cadastros"
    }, {
      title: _withCtx(() => [
        _createTextVNode(" Cadastro de Tipo de Custo "),
        _createVNode(_component_a_switch, {
          checked: _ctx.state.tipoCusto.ativo,
          "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.tipoCusto.ativo) = $event)),
          style: {"float":"right"},
          "checked-children": "Ativo",
          "un-checked-children": "Inativo"
        }, null, 8, ["checked"])
      ]),
      closeIcon: _withCtx(() => [
        _createVNode(_component_icone, { nome: "voltar" })
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          ((_ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Incluir && _ctx.telaBase.permissaoDados.incluir)
              || (_ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Visualizar && _ctx.telaBase.permissaoDados.alterar))
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("button", {
                  type: "button",
                  class: "ant-btn ant-btn-lg ant-btn-secondary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.salvar(true)))
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.modalBase.textoBotaoSalvarNovo), 1)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.salvar(false)))
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.modalBase.textoBotaoSalvar), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_skeleton, {
          loading: _ctx.telaBase.carregando
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form, { layout: "vertical" }, {
              default: _withCtx(() => [
                _createVNode(_component_card, { titulo: "DADOS PRINCIPAIS" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_a_form_item, {
                          label: "Tipo item",
                          class: "ss-margin-campos",
                          rules: [{ required: true }]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_selecionar_tipo_item, {
                              codigoSelecionado: _ctx.state.tipoCusto.tipoItem,
                              "onUpdate:codigoSelecionado": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.tipoCusto.tipoItem) = $event))
                            }, null, 8, ["codigoSelecionado"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_a_form_item, {
                          label: "Descrição",
                          class: "ss-margin-campos",
                          rules: [{ required: true }]
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              maxlength: "50",
                              class: "ant-input",
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.tipoCusto.descricao) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.state.tipoCusto.descricao]
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_a_form_item, {
                          class: "ss-margin-campos",
                          rules: [{ required: true }]
                        }, {
                          label: _withCtx(() => [
                            _hoisted_6,
                            _createVNode(_component_a_tooltip, {
                              placement: "top",
                              title: "A sigla do custo poderá ser utilizada em telas, relatórios e recursos que necessitem de uma abreviação para identificar o custo."
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_icone, {
                                  tabindex: "-1",
                                  class: "ss-icone-informacao-campo",
                                  nome: "informacao-campo"
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              maxlength: "3",
                              class: "ant-input",
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.tipoCusto.sigla) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.state.tipoCusto.sigla]
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_a_form_item, {
                          class: "ss-margin-campos",
                          rules: [{ required: true }]
                        }, {
                          label: _withCtx(() => [
                            _hoisted_8,
                            _createVNode(_component_a_tooltip, {
                              placement: "top",
                              title: "Define a quantidade de casas decimais que será apresentada quando o valor do tipo de custo for preenchido."
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_icone, {
                                  tabindex: "-1",
                                  class: "ss-icone-informacao-campo",
                                  nome: "informacao-campo"
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_selecionar_casas_decimais_valor, {
                              casasDecimais: _ctx.state.tipoCusto.casasDecimais,
                              "onUpdate:casasDecimais": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.tipoCusto.casasDecimais) = $event))
                            }, null, 8, ["casasDecimais"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_a_form_item, {
                          label: " ",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_checkbox, {
                              checked: _ctx.state.tipoCusto.producao,
                              "onUpdate:checked": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.tipoCusto.producao) = $event))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Produção")
                              ]),
                              _: 1
                            }, 8, ["checked"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_a_form_item, {
                          label: "Empresas",
                          class: "ss-margin-campos",
                          rules: [{ required: true }]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_selecionar_empresa, {
                              varias: true,
                              empresasEspecificas: _ctx.telaBase.empresasDisponiveis,
                              codigosSelecionados: _ctx.telaBase.empresasSelecionadas,
                              "onUpdate:codigosSelecionados": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.telaBase.empresasSelecionadas) = $event))
                            }, null, 8, ["empresasEspecificas", "codigosSelecionados"])
                          ]),
                          _: 1
                        })
                      ])
                    ], 512), [
                      [_vShow, _ctx.telaBase.apresentarEmpresas]
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_a_form_item, {
                          label: "Onde atualizar o Custo",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select, {
                              value: _ctx.state.tipoCusto.recursoAtualizacao,
                              "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.tipoCusto.recursoAtualizacao) = $event)),
                              class: "ss-tamanho-completo"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_select_option, { value: 'RECEBIMENTOS_MERCADORIAS' }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Recebimento Mercadoria")
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_select_option, { value: 'INDUSTRIA' }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Indústria")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_a_alert, {
                          message: "Crie a sua fórmula para decidir o que incide ou não em seu custo.",
                          type: "info",
                          "show-icon": ""
                        }, {
                          description: _withCtx(() => [
                            _hoisted_16
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_form_item, {
                          label: "Fórmula",
                          class: "ss-margin-campos",
                          rules: [{ required: true }]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_mentions, {
                              value: _ctx.state.tipoCusto.formula,
                              "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.tipoCusto.formula) = $event)),
                              rows: "3",
                              placeholder: "Exemplo: (ValorIcms + ValorIpi + ValorFrete)",
                              prefix: ['v', 'V', 'q', 'Q', 'f', 'F', '-', '+', '*', '/', '('],
                              options: _ctx.options,
                              onSearch: _ctx.onSearch,
                              onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.changeFormula()))
                            }, null, 8, ["value", "prefix", "options", "onSearch"])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_requisicao_modal, {
          visivel: _ctx.modalBase.exibirRequisicaoModal,
          "onUpdate:visivel": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
          apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
          fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso,
          retornoRequisicao: _ctx.modalBase.retornoRequisicao
        }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "retornoRequisicao"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}